export const COLOR = 'color';
